import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import getRemoteUri from "common/modules/helpers";
import { PartnerFeedItem } from "./partnerFeedApi";

interface PartnerFeedViewerDialogProps {
  feed: PartnerFeedItem;
  onClose: () => void;
}

export default function PartnerFeedViewerDialog({
  feed,
  onClose,
}: PartnerFeedViewerDialogProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const pdfUrl = getRemoteUri(feed.file);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        {feed.title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          "& iframe": {
            height: isMobile ? "calc(100vh - 200px)" : "calc(100vh - 100px)",
          },
        }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            width="100%"
            style={{ border: "none" }}
            title={feed.title}
          />
        ) : (
          <div>Nincs feltöltött PDF fájl.</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
